import React from "react";
import Swal from "sweetalert2";
import scheduleService from "../../../services/schedule.service";

const DeleteSchedule = (props: any) => {
  const { schedule } = props;
  const type = schedule.type === "tqf" ? "มคอ." : "อชว.";
  const onDelete = () => {
    Swal.fire({
      title: "คุณต้องการลบ?",
      text: `รายกำหนดการ  ${type} ปี ${schedule.year} เทอม ${schedule.term}!`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ใช่",
      cancelButtonText: "ยกเลิก",
    }).then((result) => {
      if (result.isConfirmed) {
        // console.log("ใช้ต้องการลบเดียวนี้");
        scheduleService
          .deleteSchedule(Number(schedule.id))
          .then(() => {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "บันทึกสำเร็จ",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              window.location.reload();
            });
          })
          .catch(() => {
            Swal.fire({
              position: "center",
              icon: "error",
              title: "มีบางอย่างทำงานผิดพลาด โปรดตรวจสอบก่อนครับ",
              showConfirmButton: true,
            });
          });
      }
    });
  };
  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-danger text-white ms-1"
        onClick={onDelete}
      >
        <i className="bi bi-trash3"></i> ลบ
      </button>
    </>
  );
};

export default DeleteSchedule;
